import React from "react";
import { ReviewStarIcon, TwitterIcon } from "../icons";

function PetTagReviewCard({
  name,
  location,
  orgLogo = TwitterIcon,
  reviewLogo = ReviewStarIcon,
  reviewContent,
}) {
  const ReviewIcon = reviewLogo;
  const OrgLogo = orgLogo;

  return (
    <article className="p-6 space-y-[14px] bg-white rounded-2xl w-full mx-auto md:w-[260px] shadow-pet-review-card-shadow md:shadow-none">
      <div className="flex items-center justify-between md:w-[212px]">
        <div>
          <h4 className="text-[#161C2D] text-lg leading-normal font-semibold">
            {name}
          </h4>
          <small className="text-[#737D99] font-normal text-xs">
            {location}
          </small>
        </div>
        <OrgLogo />
      </div>
      <div className=" flex items-center space-x-[6px]">
        <ReviewIcon />
        <ReviewIcon />
        <ReviewIcon />
        <ReviewIcon />
        <ReviewIcon />
      </div>

      <div className="text-[#666] font-normal text-sm leading-[21px] md:w-[212px]">
        {reviewContent}
      </div>
    </article>
  );
}

export default PetTagReviewCard;
